exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mini-sidebar .dark-logo, .mini-sidebar .light-logo {\n  width:50px !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/igor/Projects/onechat/admin-dashboard/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main